module.exports = __webpack_public_path__ + "img/27.5c5ff09b.jpg";